import { CircularProgress, Box } from '@mui/material';
import React, { useContext } from 'react';
import Context from '../../context';

const LoadingSpinner = (): JSX.Element => {
  const { isLoading } = useContext(Context);

  return !isLoading ? <></> : (
    <Box
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent dark overlay
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999, // Ensures it appears above everything
      }}
    >
      <CircularProgress style={{ color: 'primary' }} /> {/* White spinner */}
    </Box>
  );
};

export default LoadingSpinner;
